import React from 'react';
import { cn } from '../../../lib/utils';

type Size = 'sm' | 'md' | 'lg';
const sizeClass: Record<Size, string> = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[3px]',
};

export interface TaskySpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: Size;
  tone?: 'primary' | 'white';
}

export const TaskySpinner: React.FC<TaskySpinnerProps> = ({
  className,
  size = 'md',
  tone = 'primary',
  ...rest
}) => (
  <div
    role="status"
    aria-label="Loading"
    {...rest}
    className={cn(
      'rounded-full animate-spin',
      sizeClass[size],
      tone === 'primary' && 'border-gray-200 border-t-primary',
      tone === 'white' && 'border-white/30 border-t-white',
      className,
    )}
  />
);

export const TaskyLoadingOverlay: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => (
  <div
    {...rest}
    className={cn(
      'absolute inset-0 bg-black/50 rounded-tasky-md flex items-center justify-center',
      className,
    )}
  >
    {children ?? <TaskySpinner size="lg" tone="white" />}
  </div>
);

export const TaskyTypingIndicator: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...rest
}) => (
  <div
    role="status"
    aria-label="Typing"
    {...rest}
    className={cn(
      'inline-flex items-center gap-1 bg-gray-100 rounded-full px-4 py-2',
      className,
    )}
  >
    <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s', animationDuration: '1.4s' }} />
    <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s', animationDuration: '1.4s' }} />
    <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s', animationDuration: '1.4s' }} />
  </div>
);
